import React from "react";

export function Guidance(props) {
  if (!props.appsLoaded || props.apps.length !== 0) {
    return null;
  }
  return (
    <p>
      <span style={{ fontWeight: "400" }}>Note: </span>
      If you have previously created an API Application with SOS Inventory but
      do not see it listed here, please send the first 10 characters of the
      client ID to
      <span style={{ fontWeight: "400" }}> support@sosinventory.com </span>
      from the email associated with this developer portal. We will take care of
      connecting the application with your account.
    </p>
  );
}
